import { backendBaseUrl } from '../utils/platformBasedInfo';
import { useAxios } from './axiosInstance';
import { UseAxiosResult } from 'axios-hooks';
import { useEnrichWithCommonValues } from './enrichWithCommonValues';

export const ENDPOINT_SEND_BANK_STATEMENTS_LATER = `${backendBaseUrl}/api/apply/bank/send-statements-later`;

export const sendBankStatementsLater = (): UseAxiosResult => {
  const { enrich } = useEnrichWithCommonValues();
  const [{ data, loading, error }, update] = useAxios(
    {
      url: ENDPOINT_SEND_BANK_STATEMENTS_LATER,
      withCredentials: true,
      method: 'POST',
    },
    { manual: true }
  );

  return [{ data, loading, error }, enrich(update), () => {}];
};
